import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { AUTH } from '@/constants/testIds';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';

const formatApiError = (detail) => {
  if (detail == null) return 'Algo salió mal. Por favor, intenta de nuevo.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

const AuthPage = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState({ email: '', password: '' });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(loginData.email, loginData.password);
      toast.success('Inicio de sesión exitoso');
      navigate('/dashboard');
    } catch (error) {
      toast.error(formatApiError(error.response?.data?.detail) || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#F9F8F6' }}>
      <div className="w-full max-w-6xl grid md:grid-cols-2 gap-8 items-center">
        <div className="hidden md:block">
          <img
            src="https://images.pexels.com/photos/6985277/pexels-photo-6985277.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Terapia"
            className="rounded-lg shadow-lg w-full h-[600px] object-cover"
          />
        </div>

        <Card className="p-8 bg-white">
          <h1 className="text-3xl font-semibold mb-2" style={{ color: '#2D3748', fontFamily: 'Manrope' }}>
            REKORD
          </h1>
          <p className="text-sm mb-6" style={{ color: '#718096' }}>
            Sistema de gestión e informes de sesiones multisensoriales
          </p>

          <form onSubmit={handleLogin} data-testid={AUTH.loginForm} className="space-y-4">
            <div>
              <Label htmlFor="login-email">Email</Label>
              <Input
                id="login-email"
                data-testid={AUTH.loginEmail}
                type="email"
                value={loginData.email}
                onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
                required
                className="mt-1"
              />
            </div>
            <div>
              <Label htmlFor="login-password">Contraseña</Label>
              <Input
                id="login-password"
                data-testid={AUTH.loginPassword}
                type="password"
                value={loginData.password}
                onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                required
                className="mt-1"
              />
            </div>
            
            {/* Forgot Password Link */}
            <div className="text-right">
              <Link 
                to="/forgot-password" 
                className="text-sm hover:underline"
                style={{ color: '#5A7D6C' }}
              >
                ¿Olvidó su contraseña?
              </Link>
            </div>

            <Button
              type="submit"
              data-testid={AUTH.loginSubmit}
              className="w-full btn-primary"
              disabled={loading}
            >
              {loading ? 'Iniciando...' : 'Iniciar Sesión'}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-600">
            <p>¿No tiene cuenta? Contacte a su administrador para recibir una invitación.</p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default AuthPage;
